import { AccountDetailsRightMenu } from './accountDetails/AccountDetailsRightMenu';
import { RemindersRightMenu } from './children/RemindersRightMenu';
import { RemoveAccountRightMenu } from './children/RemoveAccountRightMenu';
import { TrackersRightMenu } from './children/TrackersRightMenu';
import { LanguagesRightMenu } from './languageDetails/LanguagesRightMenu';
import { ChangePasscodeRightMenu } from './securityDetails/ChangePasscodeRightMenu';
import { ChangePasswordRightMenu } from './securityDetails/ChangePasswordRightMenu';

type ProfileSettingsRightPanelProps = {
  activeMenu: { id: number };
  activeSubMenu: { id: number; title: string };
  profile: any;
  isHidden: boolean;
  saveChanges: (props: any) => void;
  changeMenu: (arg0: number, arg1: string) => void;
};

export function ProfileSettingsRightPanel({
  activeMenu,
  activeSubMenu,
  profile,
  isHidden,
  saveChanges,
  changeMenu,
}: ProfileSettingsRightPanelProps) {
  return (
    <div className={`menu-right ${isHidden ? 'simplify' : ''}`}>
      {activeMenu?.id === 41 && activeSubMenu?.id === 51 && (
        <AccountDetailsRightMenu
          hide={isHidden}
          changeMenu={changeMenu}
          profile={profile}
          saveChanges={saveChanges}
        />
      )}
      {activeMenu?.id === 42 && activeSubMenu?.id === 52 && (
        <ChangePasswordRightMenu hide={isHidden} profile={profile} changeMenu={changeMenu} />
      )}
      {activeMenu?.id === 42 && activeSubMenu?.id === 53 && (
        <ChangePasscodeRightMenu hide={isHidden} profile={profile} changeMenu={changeMenu} />
      )}
      {activeMenu?.id === 41 && activeSubMenu?.id === 54 && (
        <RemoveAccountRightMenu hide={isHidden} changeMenu={changeMenu} />
      )}
      {activeMenu?.id === 43 && activeSubMenu?.id === 55 && (
        <RemindersRightMenu hide={isHidden} changeMenu={changeMenu} />
      )}
      {activeMenu?.id === 43 && activeSubMenu?.id === 56 && (
        <TrackersRightMenu hide={isHidden} changeMenu={changeMenu} />
      )}
      {activeMenu?.id === 41 && activeSubMenu?.id === 57 && (
        <LanguagesRightMenu
          hide={isHidden}
          changeMenu={changeMenu}
          profile={profile}
          saveChanges={saveChanges}
        />
      )}
    </div>
  );
}
